import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

/**
 * 포즈(퍼펫의 핀 도구): 흐린 차렷 팔에서 만세 팔로, 화살표로 바뀌는 자세.
 * 다른 속성 아이콘과 달리 선 아이콘이라, BaseIcon이 svg에 fill="none"만
 * 주므로 선 속성은 감싸는 <g>에 직접 준다. 색은 color를 따라 탭의
 * 켜짐·꺼짐 색이 그대로 바뀐다.
 */
export const AttrPoseIcon = React.memo<IconProps>(({
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
  >
    <g stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      {/* 머리 */}
      <circle cx="10.5" cy="4" r="2.5" fill={color} stroke="none" />
      {/* 몸과 다리 */}
      <path d="M10.5 8 V14.5 M10.5 14.5 L7 21 M10.5 14.5 L14 21" />
      {/* 흐린 차렷 팔 */}
      <path d="M6.14 15.73 L10.5 9.5 L14.86 15.73" strokeOpacity={0.5} strokeWidth={1.8} />
      {/* 만세 팔 */}
      <path d="M5 4.5 L10.5 9.5 L16 4.5" />
      {/* 화살표 */}
      <path d="M16.16 15.16 A8 8 0 0 0 18.02 6.76" />
      <path d="M17.13 9.2 L18.02 6.76 L20.27 8.06" />
    </g>
  </BaseIcon>
));

AttrPoseIcon.displayName = 'AttrPoseIcon';
